import microuniversoApi from "app/api/microuniversoApi"
import * as atualizacaoOrcamentoLegadoActions from 'app/redux/atualizacaoOrcamentoLegadoSlice'
import { atualizarItemAction } from "app/redux/orcamentoSlice"
import store from "app/redux/store/store"


import { WindowMU } from "app/types/WindowMU"
import globalMU from "globalMU"

declare var window: WindowMU

export type AlterarQuantidadeItemParams = {
    identificadorItem: number,
    quantidade: number
    quantidadeEstoque: number
    quantidadeSolicitada: number
    atualizarEstadoLegadoImediatamente?: boolean
    silent?: boolean
}

export async function alterarQuantidadeItem(params: AlterarQuantidadeItemParams) {
 
    try {
        globalMU.blockUI({ tryPassiveLoading: true })

        const orcamentoAtualizado = await microuniversoApi.Orcamento.definirQuantidadeItem(
            params.identificadorItem,
            store.getState().orcamento.IdentificadorOrcamento,
            params.quantidade,
            params.quantidadeEstoque,
            params.quantidadeSolicitada)



        const atualizarOrcamentoLegado = () => {
            const orcamentoLegado = window.orcamentoController.model

            //const itemAtualizado = orcamentoAtualizado.ItensOrcamento.find(i => i.Identificador == params.identificadorItem)

            if (params.atualizarEstadoLegadoImediatamente) {
                // const itensLegado = orcamentoLegado.get('ItensOrcamento')
                // const itemLegado = itensLegado.models.find(item => item.get('Identificador') == params.identificadorItem)

                // itemLegado?.atualizar(itemAtualizado, true, true, true)
            }


            orcamentoLegado.atualizar(
                orcamentoAtualizado,    //data
                params.atualizarEstadoLegadoImediatamente == true,  //ehParaAtualizarEstadoLegado
                true,   //ehParaAtualizarRedux
                params.silent === true  //silent

            )
/*  comentado para melhorar perforamnce, diego fez testes e nao erro sem esse codigo no PCP
            if (orcamentoAtualizado?.ItensOrcamento) {
                orcamentoAtualizado.ItensOrcamento.forEach((item) => {
                    store.dispatch(atualizarItemAction({
                        identificador: item.Identificador,
                        dados: { UltimaInformacaoAtualizada: "QUANTIDADE" }
                    }))
                })
            }
*/

            if (!params.atualizarEstadoLegadoImediatamente) {
                store.dispatch(atualizacaoOrcamentoLegadoActions.atualizar(orcamentoAtualizado))
            }

            store.dispatch(atualizarItemAction({
                identificador: params.identificadorItem,
                dados: { UltimaInformacaoAtualizada: "QUANTIDADE" }
            }))

        }


        atualizarOrcamentoLegado()

        store.dispatch(atualizarItemAction({
            identificador: params.identificadorItem,
            dados: {UltimaInformacaoAtualizada: "QUANTIDADE"}
        }))
        
    } finally {
        globalMU.unblockUI()
    }


}